import { render } from "./ClientCallTab.vue?vue&type=template&id=0c8bc49a"
import script from "./ClientCallTab.vue?vue&type=script&lang=js"
export * from "./ClientCallTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__